// extracted by mini-css-extract-plugin
module.exports = {"arrow":"style_arrow__1EDg-","right":"style_right__aRq2H"};